export default __webpack_public_path__ + "static/logo.url-a718400eb3b3bd7f00d21639c7192e35.svg";